// extracted by mini-css-extract-plugin
module.exports = {"root":"Page-module--root--1vJxJ","hero":"Page-module--hero--5_yxf","contentBlocks":"Page-module--contentBlocks--3fn_I"};